<div [class.fullscreen]="isFullscreen" class="editor-container">
  <div #queryEditor class="codemirror"></div>

  <a
    (click)="toggleFullscreen()"
    class="fullscreen-toggle"
    [attr.aria-label]="isFullscreen ? 'Exit Fullscreen' : 'Enter Fullscreen'"
    [title]="isFullscreen ? 'Exit Fullscreen' : 'Enter Fullscreen'"
    ><fa-icon [icon]="isFullscreen ? 'compress' : 'expand'"></fa-icon
  ></a>

  <!-- typeahead dropdown rendered via CDK Overlay -->
  <ng-template #typeaheadDropdownTemplate>
    <app-typeahead-dropdown
      #typeaheadDropdown
      [suggestions]="autocompleteService.suggestions$ | async"
      [position]="autocompleteService.position$ | async"
      [isVisible]="autocompleteService.isVisible$ | async"
      [selectedIndex]="autocompleteService.selectedIndex$ | async"
      [maxItems]="10"
      (suggestionSelected)="onSuggestionSelected($event)"
      (suggestionHovered)="onSuggestionHovered($event)"
      (dropdownClosed)="onDropdownClosed()"
    >
    </app-typeahead-dropdown>
  </ng-template>
</div>
